export const MountingFlowMenu = {
  routes: [
    {
      name: 'load-flow',
      displayName: 'menu.load_flow',
      subject_class: "LoadSteps"
    },
    {
      name: 'mounting-flow',
      displayName: 'menu.flow',
      subject_class: "OrderSteps"
    },
    {
      name: 'statuses',
      displayName: 'menu.statuses',
      subject_class: 'Statuses'
    },
  ]
} 

        


